import _ from 'lodash'

export const entityNameSelector = (entId) => (state) =>
    state
        .getIn(['ui', 'entityStack', 'favourites', 'entities'])
        .find((entity) => _.toString(entity.get('entId')) === _.toString(entId))
        .get('name')
